/** Mirror of the backend `agents` column sizes (`admin_agent_service.py`). The slug is capped
 * at 83 so the auto-created `agent-{slug}-validators` group name fits its 100-char column. */
export const AGENT_NAME_MAX_LENGTH = 200;
export const AGENT_SLUG_MAX_LENGTH = 83;
export const AGENT_SHORT_DESCRIPTION_MAX_LENGTH = 300;
export const AGENT_MAINTAINER_MAX_LENGTH = 200;
export const AGENT_URL_MAX_LENGTH = 500;
export const AGENT_OAUTH_CLIENT_ID_MAX_LENGTH = 255;
